import React from "react";
import "./styles/Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <h1>
        Developed by{" "}
        <a
          href="https://spencerdedrick.netlify.app"
          rel="noreferrer"
          target="_blank"
        >
          Spencer Dedrick
        </a>
      </h1>
    </div>
  );
}
